module.exports = __webpack_public_path__ + "static/media/18-RotHeatExchanger - Water cool - Water heat.ef6f8920.png";